import { z } from 'zod';

import { userSchema } from './User';

/**
 * TODO: These types are for a different kind of subscription. Let's move them elsewher, consider renaming
 */
export const SubscriberSchema = z.union([z.string(), userSchema]);

export type Subscriber = z.infer<typeof SubscriberSchema>;

/**
 * END TODO
 */

export enum SubscriptionType {
    COMPANY = 'company',
    DESIGNER = 'designer',
    CREDIT = 'credit_package',
}

export const SubscriptionTypeLabelMap: Record<SubscriptionType, string> = {
    [SubscriptionType.COMPANY]: 'Company',
    [SubscriptionType.DESIGNER]: 'Designer',
    [SubscriptionType.CREDIT]: 'Credit',
};

export const AllSubscriptionTypes = [SubscriptionType.COMPANY, SubscriptionType.DESIGNER, SubscriptionType.CREDIT];

export type SubscriptionFromSubscriptionType<T extends SubscriptionType> = T extends SubscriptionType.COMPANY
    ? CompanySubscription
    : T extends SubscriptionType.DESIGNER
      ? DesignerSubscription
      : T extends SubscriptionType.CREDIT
        ? CreditSubscription
        : never;

export enum SubscriptionBillingCycle {
    MONTHLY = 'monthly',
    YEARLY = 'yearly',
}

export const SubscriptionBillingCycleSchema = z.nativeEnum(SubscriptionBillingCycle);

export enum CompanySubscription {
    NONE = 'company.none',
    PREMIUM = 'company.premium',
}

export const CompanySubscriptionSchema = z.nativeEnum(CompanySubscription);

export enum DesignerSubscription {
    NONE = 'designer.none',
    STANDARD = 'designer.standard',
}

export const DesignerSubscriptionSchema = z.nativeEnum(DesignerSubscription);

export enum CreditSubscription {
    NONE = 'credit.none',
    STANDARD = 'credit.standard',
}

export const CreditSubscriptionSchema = z.nativeEnum(CreditSubscription);

export type Subscription = CompanySubscription | DesignerSubscription | CreditSubscription;

export const SubscriptionSchema = z.union([
    CompanySubscriptionSchema,
    DesignerSubscriptionSchema,
    CreditSubscriptionSchema,
]);

export const SubscriptionDataSchema = z.object({
    subscription: SubscriptionSchema,
    quantity: z.number().min(0),
});

export type SubscriptionData = z.infer<typeof SubscriptionDataSchema>;

export const SubscriptionChangeSchema = z.union([
    z.object({
        isNew: z.literal(true),
        subscription: SubscriptionSchema,
        quantity: z.number(),
    }),
    z.object({
        isRemoved: z.literal(true),
        subscription: SubscriptionSchema,
        quantity: z.number(),
    }),
    z.object({
        isChange: z.literal(true),
        subscription: SubscriptionSchema,
        fromQuantity: z.number(),
        toQuantity: z.number(),
    }),
]);

export type SubscriptionChange = z.infer<typeof SubscriptionChangeSchema>;

export const AllCompanySubscriptions = [CompanySubscription.PREMIUM, CompanySubscription.NONE];

export const AllDesignerSubscriptions = [DesignerSubscription.NONE, DesignerSubscription.STANDARD];

export const AllCreditSubscriptions = [CreditSubscription.NONE, CreditSubscription.STANDARD];

export const AllSubscriptions = [
    ...AllCompanySubscriptions,
    ...AllDesignerSubscriptions,
    ...AllCreditSubscriptions,
] as Subscription[];

export const AllSubscriptionsByType: Record<SubscriptionType, Subscription[]> = {
    [SubscriptionType.COMPANY]: AllCompanySubscriptions,
    [SubscriptionType.DESIGNER]: AllDesignerSubscriptions,
    [SubscriptionType.CREDIT]: AllCreditSubscriptions,
};
